import { useCallback } from "react"
import { useSearchParams } from "react-router-dom"
const useNotificationCenterTemplateSearchParams = () => {
  const [searchParams] = useSearchParams()
  const getParams = useCallback(() => {
    const active = searchParams.get("active") ?? undefined
    const enabled = searchParams.get("enabled") ?? undefined
    const channel = searchParams.get("channel") ?? undefined
    const name = searchParams.get("name") ?? undefined
    return {
      active,
      enabled,
      channel,
      name,
    }
  }, [searchParams])
  const params = getParams()
  const hasParams = Object.values(params).some(
    (value) => value !== undefined
  )
  return { params, searchParams, hasParams }
}
export default useNotificationCenterTemplateSearchParams
